import { Pipe, PipeTransform } from '@angular/core';
import { ChangeLogModelKey } from '@mona/models';
import { ChangeLogMap } from '@mona/pdms/data-access-changelog';

/**
 * Returns true when any change entry for the given model key(s) has isSaving flag
 */
@Pipe({
    name: 'isModelSaving',
    standalone: false,
})
export class IsModelSavingPipe implements PipeTransform {
    /**
     * Transform implementation
     * @param changesMap ChangeLogMap
     * @param modelNames model keys to check
     */
    transform(changesMap: ChangeLogMap, ...modelNames: ChangeLogModelKey[]): boolean {
        if (!changesMap) {
            return false;
        }
        return modelNames.some(key => changesMap[key]?.some(c => c.isSaving));
    }
}
